module.exports = __webpack_public_path__ + "img/3-1.9c05ce40.svg";